<script lang="ts">
  import type { FieldState, InputEvent } from '@shared/lib/types';
  import { is } from '@shared/lib/utils';
  import { twMerge } from 'tailwind-merge';
  import { Field } from '@shared/ui/fields/field';

  export let placeholder = '';
  export let required = false;
  export let label: string | undefined = undefined;
  export let helperText: string | undefined = undefined;
  export let fieldClass = '';
  export let state: FieldState = 'default';
  export let value: string;
  export let name: string;
  export let noMargin = false;

  function inputHandler(e: InputEvent) {
    state === 'error' && (state = 'default') && (helperText = '');
    value = e.currentTarget.value.trim();
  }
</script>

<Field {state} {label} {helperText} {noMargin}>
  <textarea
    class="{twMerge(
      'input placeholder-dark-800 dark:placeholder-dark-500 h-36 w-full resize-none border-none bg-transparent px-3 py-3 outline-none',
      fieldClass,
    )}"
    on:focus="{() => state === 'error' || state === 'success' || (state = 'active')}"
    on:blur="{() => state === 'error' || state === 'success' || (state = 'default')}"
    {required}
    placeholder="{placeholder + (required ? '*' : '')}"
    disabled="{state === 'disabled'}"
    on:input="{inputHandler}"
    {name}>{is(value !== undefined, value)}</textarea
  >
  <slot />
</Field>
